import React from 'react'

class Footer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <footer id="footer" className="grid-restrain">
        <div className="container">
          <div className="col-md-4 col-sm-4 col-xs-12">
            <div className="footer-copyright pt-40">
              <p>SnapTest is a product of Prolific Devs - ©</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-12">
          </div>
          <div className="col-md-4 col-sm-4 col-xs-12">
            <div className="sub-footer-menu pt-40">
              <div><a href="/privacy-policy">Privacy Policy</a></div>
              <div><a href="/terms-of-service">Terms and Conditions</a></div>
            </div>
          </div>
        </div>
      </footer>
    )
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/marketing/Footer.js